import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AppSettingReq, AppSettingRes, Pagable} from '@app/core/models';
import {environment} from '@environments/environment';
import {Observable, shareReplay, take} from 'rxjs';
import {ContactRequest, Gopon_Home, NotificationRes, PageContentRes,} from '@core/models/general/general.models';
import GoponRes from '@core/models/gopon-res.model';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  private baseUrl = environment.API_BASE_URL + 'General/';
  private getAppSettingsUrl = this.baseUrl + 'GetAppSettings';
  private getPageUrl = this.baseUrl + 'GetPage';
  private contactRequestUrl = this.baseUrl + 'ContactRequest';
  private getNotificationsUrl = this.baseUrl + 'GetNotifications';
  private setNotificationSeenUrl = this.baseUrl + 'SetNotificationSeen';
  private deleteNotificationUrl = this.baseUrl + 'DeleteNotification';
  constructor(private readonly http: HttpClient) {}

  getAppSetting(body: AppSettingReq): Observable<AppSettingRes> {
    return this.http.get<AppSettingRes>(this.getAppSettingsUrl, {
      params: body as any,
    });
  }
  getPage(
    pageName: 'aboutus' | 'terms' | 'policy' | 'contactus'
  ): Observable<PageContentRes> {
    return this.http
      .get<PageContentRes>(this.getPageUrl, { params: { pageName } })
      .pipe(shareReplay(1), take(1));
  }
  contactRequest(body: ContactRequest): Observable<GoponRes> {
    return this.http
      .post<GoponRes>(this.contactRequestUrl, { contactRequest: body })
      .pipe(shareReplay(1), take(1));
  }
  getNotifications(body: Pagable): Observable<NotificationRes> {
    return this.http
      .get<NotificationRes>(this.getNotificationsUrl, { params: body as any })
      .pipe(shareReplay(1), take(1));
  }
  setNotificationSeen(notificationId: number): Observable<GoponRes> {
    return this.http
      .put<GoponRes>(this.setNotificationSeenUrl, { notificationId })
      .pipe(shareReplay(1), take(1));
  }
  deleteNotification(notificationId: number): Observable<GoponRes> {
    return this.http
      .delete<GoponRes>(this.deleteNotificationUrl, {
        params: { notificationId },
      })
      .pipe(shareReplay(1), take(1));
  }

}
